/**
 * @file NewAnnotationCard.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Mar 22, 2022 09:45
 */
import { Fragment } from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import { stringExists } from 'src/@common/utilities';
import VeriomeSelectField from 'src/components/fieldComponents/VeriomeSelectField';

function NewAnnotationCard(props) {
    const {
        formFields,
        handleChange,
        handleSubmit,
    } = props;

    const options = [
        {
            label: 'ACMG',
            value: 'acmg'
        },
        {
            label: 'General Feature',
            value: 'generalFeature'
        },
    ];

    const fieldErrors = {};

    let disableSubmitButton = false;
    if (!stringExists(formFields.annotationType)) {
        disableSubmitButton = true;
    }

    let helpText = '';
    if (!stringExists(formFields.annotationType)) {
        helpText = 'Select an annotation type';
    }

    return (

        <Fragment>

            <Box>

                <VeriomeSelectField
                    className={''}
                    fieldLabel={'Annotation Type'}
                    fieldName={'annotationType'}
                    currentValue={formFields.annotationType ? formFields.annotationType : ''}
                    options={options}
                    fieldErrors={fieldErrors}
                    helpText={helpText}
                    isFocus={true}
                    isRequired={true}
                    sxStyle={{
                        width: '300px',
                        mr: '10px'
                    }}
                    handleBlur={() => {
                        // handleBlur(fieldName);
                    }}
                    handleChange={(event) => {
                        handleChange(event, 'annotationType');
                    }}
                />

                <div className="pt-10 flex justify-between items-center">
                    <Button
                        variant="outlined"
                        color="secondary"
                        type="submit"
                        size="small"
                        disabled={disableSubmitButton}
                        onClick={(event) => {
                            handleSubmit(event);
                        }}
                    >
                        Submit
                    </Button>
                </div>

            </Box>

        </Fragment >

    );
}

NewAnnotationCard.propTypes = {
    formFields: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
};

export default NewAnnotationCard;